<template>
  <div class="product-list">
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <!--      <el-tabs v-model="activeName" @tab-click="handleClick">-->
      <!--        <el-tab-pane label="出售中" name="sell">-->
      <!--          <span slot="label">出售中 <el-tag size="mini">{{ totalDataNumber }}</el-tag></span>-->
      <!--        </el-tab-pane>-->
      <!--        <el-tab-pane label="仓库中" name="lower">-->
      <!--          <span slot="label">仓库中 <el-tag size="mini">{{ productCount.lower }}</el-tag></span>-->
      <!--        </el-tab-pane>-->
      <!--        <el-tab-pane label="回收站" name="recovery">-->
      <!--          <span slot="label">回收站 <el-tag size="mini">{{ productCount.recovery }}</el-tag></span>-->
      <!--        </el-tab-pane>-->
      <!--        <el-tab-pane label="库存紧张" name="stock">-->
      <!--          <span slot="label">库存紧张 <el-tag size="mini">{{ productCount.stock }}</el-tag></span>-->
      <!--        </el-tab-pane>-->
      <!--        <el-tab-pane label="草稿箱" name="draft">-->
      <!--          <span slot="label">草稿箱 <el-tag size="mini">{{ productCount.draft }}</el-tag></span>-->
      <!--        </el-tab-pane>-->
      <!--        <el-tab-pane label="待审核" name="audit">-->
      <!--          <span slot="label">待审核 <el-tag size="mini">{{ productCount.audit }}</el-tag></span>-->
      <!--        </el-tab-pane>-->
      <!--        <el-tab-pane label="未通过" name="noAudit">-->
      <!--          <span slot="label">未通过 <el-tag size="mini">{{ productCount.noAudit }}</el-tag></span>-->
      <!--        </el-tab-pane>-->
      <!--      </el-tabs>-->
      <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
        <!--        <el-form-item>-->
        <!--          <el-button size="small" type="primary" icon="el-icon-plus" @click="addClick" v-auth="'/product/product/add'">-->
        <!--            添加自营产品-->
        <!--          </el-button>-->
        <!--        </el-form-item>-->
        <el-form-item label="商品分类">
          <el-select size="small" v-model="searchForm.categoryId" placeholder="所有分类">
            <el-option label="全部" value="0"></el-option>
            <el-option v-for="(item, index) in categoryList" :key="index" :label="item.name"
                       :value="item.categoryId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="商品名称">
          <el-input size="small" v-model="searchForm.productName" placeholder="请输入商品名称"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!--添加产品-->
    <!--    <div class="common-level-rail">-->
    <!--      <el-button size="small" type="primary" icon="el-icon-plus" @click="addClick" v-auth="'/product/product/add'">-->
    <!--        添加产品-->
    <!--      </el-button>-->
    <!--    </div>-->

    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
          <el-table-column prop="productName" label="产品">
            <template slot-scope="scope">
              <div class="product-info">
                <div class="pic"><img v-img-url="scope.row.imagePath" alt=""/></div>
                <div class="info">
                  <div class="name">{{ scope.row.productName }}</div>
                  <div class="price">￥{{ scope.row.productPrice }}</div>
                </div>
              </div>
            </template>
          </el-table-column>
          <!--          <el-table-column prop="manufacturer" label="生产商" width="200px">-->
          <!--          </el-table-column>-->
          <el-table-column prop="productBrand" label="品牌" width="200px"></el-table-column>
          <el-table-column prop="spec" label="规格" width="200px">
            <template slot-scope="scope">
              {{ getSpecName(scope.row.sku) }}
            </template>
          </el-table-column>

          <!--          <el-table-column prop="categoryName" label="分类" width="200px">-->
          <!--            <template slot-scope="scope">-->
          <!--              <span>-->
          <!--                {{ getShowCategoryName(scope.row.productCategoryReList) }}-->
          <!--              </span>-->
          <!--            </template>-->
          <!--          </el-table-column>-->
          <!--          <el-table-column prop="commissionType" label="佣金类型" width="180">-->
          <!--            <template slot-scope="scope">-->
          <!--              <span>{{-->
          <!--                  scope.row.commissionType === 10 ? '百分比' : scope.row.commissionType === 20 ? '固定金额' : ''-->
          <!--                }}</span>-->
          <!--            </template>-->
          <!--          </el-table-column>-->
          <!--          <el-table-column prop="salesActual" label="销售金额" width="100px"></el-table-column>-->
          <!--                    <el-table-column prop="productStock" label="库存" width="180"></el-table-column>-->
          <el-table-column prop="highSaleCommission" label="销售佣金" width="100px">
            <template slot-scope="scope">
              {{ scope.row.minSaleCommission }} <span
              v-if=" scope.row.highSaleCommission &&  (scope.row.highSaleCommission !== scope.row.minSaleCommission)">- {{
                scope.row.highSaleCommission
              }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="highTechnicalCommission" label="技术补贴" width="100px">
            <template slot-scope="scope">
              {{ scope.row.minTechnicalCommission }} <span
              v-if=" scope.row.highTechnicalCommission &&  (scope.row.highTechnicalCommission !== scope.row.minTechnicalCommission)">- {{
                scope.row.highTechnicalCommission
              }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="highPlatCommission" label="平台补贴" width="100px">
            <template slot-scope="scope">
              {{ scope.row.minPlatCommission }} <span
              v-if=" scope.row.highPlatCommission &&  (scope.row.highPlatCommission !== scope.row.minPlatCommission)">- {{
                scope.row.highPlatCommission
              }}</span>
            </template>
          </el-table-column>
          <!--          <el-table-column label="商品属性">-->
          <!--            <template slot-scope="scope">-->
          <!--              <span v-if="scope.row.isVirtual == 0">实物商品</span>-->
          <!--              <span v-if="scope.row.isVirtual == 1" class="green">虚拟商品</span>-->
          <!--            </template>-->
          <!--          </el-table-column>-->
          <el-table-column prop="createTime" label="发布时间" width="150"></el-table-column>
          <!--          <el-table-column prop="productSort" label="排序"></el-table-column>-->
          <el-table-column fixed="right" label="操作" width="80">
            <template slot-scope="scope">
              <div class="table-btn-column">
                <!--                <el-button @click="editClick(scope.row)" type="text" size="small" v-auth="'/product/product/edit'">-->
                <!--                  编辑商品-->
                <!--                </el-button>-->
                <span @click="delClick(scope.row)"
                      style="cursor: pointer;color: red"
                      v-auth="'/product/supplier/choose/delete'"
                      v-if="scope.row.hasConsignment === 1">
                  下架商品
                </span>
                <span @click="addSupplerProductClick(scope.row)"
                      style="cursor: pointer;color: #409eff"
                      v-auth="'/product/supplier/choose/index'"
                      v-if="scope.row.hasConsignment === 0">
                  添加分销
                </span>
                <!--                <el-button v-if="activeName == 'sell'" @click="changeStatus(scope.row, 20)" type="text" size="small"-->
                <!--                           v-auth="'/product/product/edit'">立即下架-->
                <!--                </el-button>-->
                <!--                <el-button v-if="activeName == 'lower'" @click="changeStatus(scope.row, 10)" type="text" size="small"-->
                <!--                           v-auth="'/product/product/edit'">立即上架-->
                <!--                </el-button>-->
                <!--                <el-button @click="copyClick(scope.row)" type="text" size="small" v-auth="'/product/product/edit'">-->
                <!--                  一键复制-->
                <!--                </el-button>-->
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!--分页-->
    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        background
        :current-page="curPage"
        :page-size="pageSize"
        layout="total, prev, pager, next, jumper"
        :total="totalDataNumber"
      ></el-pagination>
    </div>
    <getproduct :isproduct="open_product" :islist="true" @closeDialog="closeDialogFunc($event, 'add')"/>

  </div>
</template>

<script>
import PorductApi from '@/api/product.js'
import getproduct from '@/components/product/Product.vue'

export default {
  components: {getproduct},
  data () {
    return {
      /*切换菜单*/
      activeName: 'sell',
      /*切换选中值*/
      activeIndex: '0',
      /*是否正在加载*/
      loading: true,
      /*一页多少条*/
      pageSize: 15,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*搜索参数*/
      searchForm: {
        productName: '',
        categoryId: ''
      },
      /*列表数据*/
      tableData: [],
      /*全部分类*/
      categoryList: [],
      productCount: {},
      open_product: false,
    }
  },
  created () {
    /*获取列表*/
    this.getData()
  },
  methods: {
    /*选择第几页*/
    handleCurrentChange (val) {
      let self = this
      self.loading = true
      self.curPage = val
      self.getData()
    },

    /*每页多少条*/
    handleSizeChange (val) {
      this.pageSize = val
      this.getData()
    },

    /*切换菜单*/
    handleClick (tab, event) {
      let self = this
      self.curPage = 1
      self.getData()
    },

    /*获取列表*/
    getData () {
      let self = this
      let Params = self.searchForm
      Params.pageIndex = self.curPage
      Params.pageSize = self.pageSize
      Params.type = self.activeName
      self.loading = true
      Params.isEnableCommission = 1
      Params.isChoose = 0
      PorductApi.chooseLists(Params, true)
        .then(res => {
          self.loading = false
          self.tableData = res.data.productList.records
          self.categoryList = res.data.categoryList
          self.totalDataNumber = res.data.productList.total
          self.productCount = res.data.productCount
          self.supplierStatus = res.data.supplierStatus
        })
        .catch(error => {
          self.loading = false
        })
    },

    /*搜索查询*/
    onSubmit () {
      this.curPage = 1
      this.getData()
    },

    /*打开添加*/
    addClick () {
      this.$router.push('/product/product/add')
    },

    /*打开编辑*/
    editClick (row) {
      console.log(row)
      this.$router.push({
        path: '/product/product/edit',
        query: {
          productId: row.productId,
          scene: 'edit'
        }
      })
    },

    linkClick: function (val) {
      let self = this
      let copyText = 'pages/product/detail/detail?productId=' + val
      self.$copyText(copyText).then(function (e) {
        self.$message({
          showClose: true,
          message: '复制成功',
          type: 'success'
        })
      }, function (e) {
        self.$message({
          showClose: true,
          message: '复制失败',
          type: 'error'
        })
      })
    },
    /*打开复制*/
    copyClick (row) {
      this.$router.push({
        path: '/product/product/edit',
        query: {
          productId: row.productId,
          scene: 'copy'
        }
      })
    },
    /*删除*/
    delClick: function (row) {
      let self = this
      let msg = ''
      msg = '删除后将不再分销该产品，确定删除该产品吗?'

      self
        .$confirm(msg, '提示', {
          type: 'warning'
        })
        .then(() => {
          PorductApi.supplierDeleteConsignmentProduct({
            productIds: [row.productId]
          }).then(data => {
            self.$message({
              message: '删除成功',
              type: 'success'
            })
            self.getData()
          })
        })
    },
    /*修改状态*/
    changeStatus (item, value) {
      let self = this
      let msg = ''
      if (value == 10) {
        msg = '确认要上架该商品吗?'
      } else {
        msg = '确认要下架该商品吗?'
        if (self.activeName == 'recovery') {
          msg = '确认要移动该商品到仓库吗?'
        }
      }
      self.$confirm(msg, '提示', {
        type: 'warning'
      })
        .then(() => {
          PorductApi.changeStatus({
            productId: item.productId,
            state: value
          }).then(data => {
            self.$message({
              message: '操作成功',
              type: 'success'
            })
            self.getData()
          })
        })
    },

    /*打开弹出层*/
    selectProductClick () {
      this.open_product = true
    },

    /*关闭获取用户弹窗*/
    closeDialogFunc (e) {
      let self = this
      if (e.type != 'error') {
        // this.userInfo = e.params[0];
        // this.form.supplier.userId = e.params[0].userId;
        let productIds = []

        productIds = e.params.map(item => {
          return item.productId
        })

        let params = {
          productIds: productIds
        }
        PorductApi.addSupplierProduct(params).then(res => {

          self.$message({
            message: '添加成功',
            type: 'success'
          })
          self.getData()
        }).catch(err => {
          self.$message({
            message: err.msg || '添加失败',
            type: 'error'
          })
        })
      }
      this.open_product = false
    },
    getShowCategoryName (list) {
      let text = ''
      if (list && list.length) {
        text = list.map(item => {
          return item.categoryName
        }).join(',')
      }
      return text
    },
    getSpecName (list) {
      let text = ''
      if (list && list.length) {
        let resultList = list.filter(res => res.specName)
        if (resultList && resultList.length) {
          text = resultList[0].specName
        }
      }
      return text
    },
    addSupplerProductClick (row) {
      let self = this
      let productIds = [row.productId]
      let params = {
        productIds: productIds
      }
      PorductApi.addSupplierProduct(params).then(res => {

        self.$message({
          message: '添加成功',
          type: 'success'
        })
        self.getData()
      }).catch(err => {
        self.$message({
          message: err.msg || '添加失败',
          type: 'error'
        })
      })
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/product/product/consignmentindex.vue